export default __webpack_public_path__ + "static/media/declaration-mymedikal.94ac5279.pdf";